(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var offerEl = document.querySelector('[data-ncc-free-offer]');
    if (!offerEl) return;

    var code = offerEl.getAttribute('data-ncc-free-offer-code');
    if (!code) return;

    var sessionKey = 'ncc_discount_applied_' + code;
    var alreadyHandled = false;
    try {
      alreadyHandled = window.sessionStorage.getItem(sessionKey) === '1';
    } catch (e) {}
    if (alreadyHandled) return;

    try {
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (e) {}

    var redirectTo = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + code + '?redirect=' + encodeURIComponent(redirectTo);
  });
  } catch(e) { console.error(e); }
})();

})();
